import React from 'react';
import styled from "styled-components";
import { BodyVerySmall } from "../../../../atoms/fonts/Body";
import Colours from "../../../../atoms/Colours";
import { WhereaboutsOption } from '@features/whereabouts/services/WhereaboutOptions';
import { tablet } from "../../../../atoms/MediaQueries";

export function MovementCustomLabel(props: Props) {
  const {amOption, pmOption} = props;

  if (!amOption || !pmOption) return null;

  const isCustomAmOption = !amOption.required && amOption.pickable;
  const isCustomPmOption = !amOption.required && amOption.pickable;
  if (isCustomAmOption || isCustomPmOption) {
    if (amOption.label === pmOption.label) {
      // Append the picked option item when it's the same all day; split-day
      // detail is available on hover instead.
      const optionItemLabel = props.amOptionItemLabel === props.pmOptionItemLabel ? props.amOptionItemLabel : undefined;
      const label = optionItemLabel ? `${amOption.label} - ${optionItemLabel}` : amOption.label;
      return <UsersWhereaboutsLabel title={label}
                                    weight={400}
                                    onClick={(e: any) => !!props.onLabelClicked ? props.onLabelClicked(e) : (() => {})}
                                    hasDayNote={!!props.dayNote}>{label}</UsersWhereaboutsLabel>
    } else {
      return null
    }

  } else {
    return null;
  }
}

interface Props {
  amOption?: WhereaboutsOption;
  pmOption?: WhereaboutsOption;
  dayNote?: string;
  amOptionItemLabel?: string;
  pmOptionItemLabel?: string;
  onLabelClicked?: (e: any) => any;
}

const UsersWhereaboutsLabel = styled(BodyVerySmall)<any>`
  text-align: left;
  align-self: flex-start;
  margin: 4px 4px 0 4px;
  font-size: 14px;
  max-width: ${props => props.hasDayNote ? '75%' : '100%'};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: ${Colours.black};
  text-decoration: underline;
  padding-bottom: 8px;
  a {
    color: ${Colours.black};
  }
  @media (${tablet}) {
    text-decoration: none;
    padding-bottom: 0;
  }
`;
